<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'accountTerminology', params: {} }">
            Account Terminology
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'accountTerminologyView', params: {} }">
              View Account Terminology
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Account Terminology
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="accountTerminology.name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ accountTerminology.name }}</td>
          </tr>
          
          <tr v-if="accountTerminology.value">
            <td max-width="35%" class="text-subtitle-1">Value:</td>
            <td>{{ accountTerminology.value }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getAccountTerminology } from "@/services/accountTerminology";
    

    export default {
      data() {
        return {
            id: '',
            accountTerminology: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "accountTerminologyEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getAccountTerminology(this.id)
            .then((response) => {
              this.accountTerminology = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading accountTerminology");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    